import { useState, useEffect, useRef } from "react";
import axios from 'axios';
import config from "../../Common/Configurations/APIConfig";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";
import APIConfig from "../../Common/Configurations/APIConfig";
import { useNavigate } from "react-router-dom";
import UserTab from "./UserTab";
import Header from "../../Common/Layout/Header";
import SideBar from "../../Common/Layout/Sidebar";
const initialFieldValues = {
    lendingApplicationId: "00000000-0000-0000-0000-000000000000",
    userId: "00000000-0000-0000-0000-000000000000",
    applicationFile: null,
    imageSrc: "",
};
export default function UploadApplication() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [values, setValues] = useState(initialFieldValues);
    const [errors, setErrors] = useState({});
    const [selectedFile, setSelectedFile] = useState(null);
    const headerconfig = {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken")
        }
    }
    const handleFileChange = e => {
        if (e.target.files && e.target.files[0]) {
            let applicationFile = e.target.files[0];
            setSelectedFile(applicationFile);
            const reader = new FileReader();
            reader.onload = x => {
                setValues({
                    ...values,
                    applicationFile,
                    imageSrc: x.target.result
                })
            }
            reader.readAsDataURL(applicationFile)
            handleSubmit(applicationFile);
        }
        else {
            setValues({
                ...values,
                applicationFile: null,
                imageSrc: ""
            })
        }
    }
    const validate = () => {
        let temp = {};
        temp.applicationFile = values.applicationFile === undefined ? false : true;
        temp.imageSrc = values.imageSrc === undefined ? false : true;
        setErrors(temp);
        return Object.values(temp).every((x) => x === true);
    };
    const handleSubmit = (applicationFile) => {
        //e.preventDefault();
        setLoading(true);
        var formData = new FormData()
        formData.append("lendingApplicationId", values.lendingApplicationId)
        formData.append("userId", localStorage.getItem('userId'))
        formData.append("clientId", localStorage.getItem('clientId'))
        formData.append("applicationFile", applicationFile)
        upload(formData);
    };
    const applicationAPI = () => {
        return {
            upload: (newrecord) => axios.post(config.APIACTIVATEURL + config.UPLOADLENDINGAPPLICATION, newrecord, { ...headerconfig })
        };
    };
    const upload = (formData) => {
        applicationAPI().upload(formData)
            .then((res) => {
                if (res.data.statusCode === 200) {
                    handleSuccess("Application uploaded successfully");
                    navigate("/userdashboard/application/" + res.data.data);
                    setLoading(false);
                }
                else {
                    handleError("Error in uploading application file");
                    setLoading(false);
                }
            })
            .catch(function (error) {
                handleError("Error in updating data");
                setLoading(false);
            });
    };
    const resetForm = () => {
        setValues(initialFieldValues);
        setSelectedFile(null);
    };
    const fileInputRef = useRef(null);
    const handleClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const applyErrorClass = (field) =>
        field in errors && errors[field] === false ? " form-control-danger" : "";
    return (
        <div id="layout-wrapper">
            <Header></Header>
            <SideBar></SideBar>
            <div className="vertical-overlay" />
            <div className="main-content">
                <div className="page-content">
                    <div className="card">
                        <div className="card-body">
                            <form onSubmit={handleSubmit} autoComplete="off" noValidate>
                                <div className="row justify-content-center text-center">
                                    <div className="col-lg-12 mb-3">
                                        <h5>United Lending Application</h5>
                                    </div>
                                    <div className="dropzone mb-3" onClick={handleClick} style={{ cursor: loading ? "not-allowed" : "pointer" }}>
                                        <div className="fallback">
                                            <input ref={fileInputRef} type="file" accept="application/pdf" onChange={handleFileChange} name="imageSrc" style={{ display: "none" }} />
                                        </div>
                                        <div className="dz-message needsclick">
                                            <div className="mb-3">
                                            {loading?<img src="/assets/images/uploadloading.gif" width="60px" height="60px"></img>
                                                    :<i className="display-4 text-muted ri-upload-cloud-2-fill"></i>}
                                            </div>
                                            <h4>{loading ? "Uploading... Please wait." : "Click here to upload new application form."}</h4>
                                        </div>
                                    </div>
                                    {errors.imageSrc === false ? (<div className="validationerror">Please select application form</div>) : ('')}
                                    {/* <div className="col-lg-12 mb-3 d-flex justify-content-center align-items-center gap-3">
                                        {selectedFile && (
                                            <div style={{ marginTop: "10px", fontSize: "16px", color: "#333" }}>
                                                <strong>Selected File:</strong> {selectedFile.name}
                                            </div>
                                        )}
                                        {loading === false ? (
                                            <button type="submit" className="btn btn-primary">
                                                <i className="ri-upload-2-fill me-1 align-bottom" /> Upload
                                            </button>
                                        ) : (
                                            <button type="button" className="btn btn-info" disabled>
                                                Uploading...
                                            </button>
                                        )}
                                        <button type="button" className="btn btn-danger" onClick={resetForm}>
                                            Cancel
                                        </button>
                                    </div> */}
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}